import { useId } from 'react';
import { Link } from 'react-router-dom';
import styles from './ExploreMoreLinks.module.css';

export type ExploreMoreLink = {
    label: string;
    to: string;
    reloadDocument?: boolean;
};

interface ExploreMoreLinksProps {
    links: ExploreMoreLink[];
    title?: string;
    wide?: boolean;
}

export default function ExploreMoreLinks({ links, title = 'Encore plus à découvrir', wide = false }: ExploreMoreLinksProps) {
    const headingId = useId();
    if (links.length === 0) return null;

    return <section className={`${styles.section} ${wide ? styles.sectionWide : ''}`} aria-labelledby={headingId}>
        <h2 id={headingId} className={styles.title}>{title}</h2>
        <nav className={styles.grid} aria-label={title}>
            {links.map((link) => <Link
                key={`${link.to}-${link.label}`}
                to={link.to}
                reloadDocument={link.reloadDocument}
                className={styles.link}
            >
                <span>{link.label}</span>
                <span className={styles.arrow} aria-hidden="true">→</span>
            </Link>)}
        </nav>
    </section>;
}
